<template>
    <multiselect 
        v-model="selected" 
        :allowEmpty="false" 
        :options="options" 
        track-by="value" 
        label="text" 
        placeholder="Select one" 
        selectLabel=""
        selectedLabel=""
        deselectLabel=""
        :searchable="true"
        @input="countrySelected"
        >
        </multiselect>
</template>
<script>
    import countries from '../data/countries.js'
    import Multiselect from 'vue-multiselect'

    export default {
        props: ['value'],
        components: { Multiselect },
        data() {
            return {
                selected: null
            };
        },
        mounted () {
            if (this.value && this.value !== '') {
                this.selected = this.options.find(country => country.value === this.value)
            }
        },
        computed: {
            options () {
                let arr = []
                for (var abbr in countries) {
                    arr.push({value: abbr, text: countries[abbr]})
                }
                return arr
            },
            
        },
        methods: {
            countrySelected (obj) {
                if (obj && obj.value) {
                    this.$emit('input', obj.value)
                }
            }
        }
    };
</script>


// WEBPACK FOOTER //
// prompts/components/CountrySelect.vue